export default function hashValue(input: string) {
  let result = 0;

  for (let i = 0; i < input.length; i++) {
    result = (result << 5) + input.charCodeAt(i);
    result = result & result; // Convert to 32bit integer
  }

  return Math.abs(result);
}
